import { useEffect, useState } from 'react';
import { operatorDashboardService, OperatorDashboardCountersDto } from '../services/operatorDashboardService';
import { getItem } from '../utils/localStorageHelper';
import { DELIVERY_TODAY_FILTER_KEY } from '../components/warehouse/modules/picking/pickingFilters';

/**
 * Nøkkeltall til operatørdashbordets modulkort (Teamwork 36340292).
 *
 * Hentes asynkront ETTER at dashbordet har rendret — en treg eller feilende
 * henting blokkerer aldri inngangssiden (kortene vises da bare uten tall).
 * Plukk-telleren speiler enhetens «forfalt/i dag»-filter (samme localStorage-
 * nøkkel som plukkmodulen), så kortet stemmer med det operatøren faktisk ser.
 */
export function useDashboardCounters(warehouseId?: string | null) {
  const [counters, setCounters] = useState<OperatorDashboardCountersDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    const dueTodayOnly = getItem<boolean>(DELIVERY_TODAY_FILTER_KEY) === true;

    operatorDashboardService
      .getCounters(warehouseId || undefined, dueTodayOnly)
      .then(result => {
        if (!cancelled) setCounters(result);
      })
      .catch(err => {
        // Stille feil: kortene vises uten tall — aldri feilmelding på inngangssiden.
        console.warn('Kunne ikke hente dashbord-tellere:', err);
        if (!cancelled) setCounters(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [warehouseId]);

  return { counters, loading };
}
